import { render } from "./WomenShoes4.vue?vue&type=template&id=0687a1d5"
import script from "./WomenShoes4.vue?vue&type=script&lang=js"
export * from "./WomenShoes4.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__